import { createGenericColumn } from '../../../utils/table-headers-utils';

export const playlistPlayerColumns = [
  createGenericColumn('Title'),
  createGenericColumn('Duration'),
];
